// Components
import { Link } from '@tracklib/kit'
import CoverArt from 'components/coverart'
import Artists from 'components/track/artists'

// Hooks
import { useAudioContext } from 'modules/audio/hooks'

// Types
import { Song, Track } from 'types'

import styles from './info.css'

export const renderTitle = (song: Song, track: Track, showTrackName = false, onlyTrackName = false): string => {
  if (onlyTrackName) {
    return track.name
  }
  return track.types?.includes(17) ? `${song.title}${showTrackName ? ' - Master' : ''}` : `${song.title} - ${track.name}`
}
export const renderLink = (song: Song, track: Track) =>
  track.types?.includes(17) ? `/song/${song.slug}/` : `/song/${song.slug}/#${track.slug}`

type InfoProps = {
  song: Song
  track: Track
  expanded?: boolean
}

const Info = ({ song, track, expanded }: InfoProps): JSX.Element => {
  const audioContext = useAudioContext()

  return (
    <div className={expanded ? styles.wrapperExpanded : styles.wrapper} datatesting="player_info">
      {expanded ? (
        <div className={styles.coverArtContainer}>
          <CoverArt cover={song.cover} className={styles.coverArt} sizes="(min-width: 769px) 74px, 100vw" />
        </div>
      ) : (
        <Link to={`/song/${song.slug}/`} className={styles.coverArtContainer}>
          <CoverArt cover={song.cover} className={styles.coverArt} sizes="(min-width: 769px) 74px, 100vw" />
        </Link>
      )}
      <div className={styles.songInfoInner}>
        <Link to={renderLink(song, track)} id="title" className={styles.songTitle} title={renderTitle(song, track)}>
          {renderTitle(song, track)}
        </Link>
        <div className={styles.artistName}>
          <Artists artists={song.artists} genres={song.genres} />
        </div>
        {audioContext && !expanded && (
          <div className={styles.context}>
            Playing from <Link to={audioContext.url}>{audioContext.title}</Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default Info
